import { render, staticRenderFns } from "./notification.vue?vue&type=template&id=860d0b5e&"
import script from "./notification.vue?vue&type=script&lang=ts&"
export * from "./notification.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports